import { connect } from "react-redux";

import { FullFormState } from "../../../../../Engine/Core/Store/FullFormState";
import { withViewModelSelect } from "../../../../withViewModelSelect";
import { ViewModelSelect } from "../../../../../Helpers/StateAccessors/ViewModelSelect";
import { CandyDispatch } from "../../../../../Engine/Core/Store/CandyReduxTypes";
import { setToModel } from "../../../../../Engine/ActionCreators/AllActionCreators";

import { FiasWidget, FiasWidgetProps } from "./FiasWidget";
import { buildValidationInfo } from "./Utils/FiasValidationInfoBuilder";

export interface FiasWidgetContainerProps
    extends Omit<FiasWidgetProps, "portalUserId" | "isFormInitialized" | "validationInfo" | "onRootValueChange"> {
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: FiasWidgetContainerProps) => ({
    portalUserId: state.settings.portalUserId ?? "",
    isFormInitialized: !!state.viewModel,
    validationInfo: buildValidationInfo(ownProps.value, ownProps, state),
});

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: FiasWidgetContainerProps) => ({
    onRootValueChange: async (value: string) => {
        dispatch(setToModel(ownProps.bindingPath, "value", value));
    },
});

export const FiasWidgetContainer = withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(FiasWidget));
